import { FilterData, FiltrosAPI } from "../types/filtros.types";

/**
 * Mapeia os filtros do FilterDrawer para o formato esperado pela API
 * @param filtros - Objeto com os filtros aplicados no FilterDrawer
 * @returns Objeto formatado para envio à API
 */
export const mapearFiltrosParaAPI = (
  filtros: Partial<FilterData>
): FiltrosAPI => {
  const filtrosAPI: FiltrosAPI = {};

  // Datas
  if (filtros.filtrarPor === "criacao") {
    if (filtros.inicioIntervaloCadastroLead) {
      [filtrosAPI.inicioIntervaloCadastroLead] =
        filtros.inicioIntervaloCadastroLead.toISOString().split("T");
    }
    if (filtros.fimIntervaloCadastroLead) {
      [filtrosAPI.fimIntervaloCadastroLead] = filtros.fimIntervaloCadastroLead
        .toISOString()
        .split("T");
    }
  } else if (filtros.filtrarPor === "atualizacao") {
    if (filtros.inicioIntervaloAtualizacaoLead) {
      [filtrosAPI.inicioIntervaloAtualizacaoLead] =
        filtros.inicioIntervaloAtualizacaoLead.toISOString().split("T");
    }
    if (filtros.fimIntervaloAtualizacaoLead) {
      [filtrosAPI.fimIntervaloAtualizacaoLead] =
        filtros.fimIntervaloAtualizacaoLead.toISOString().split("T");
    }
  }

  // Motivos de desqualificação
  if (
    filtros.idsMotivosDesqualificacaoLeadSistemaOrigem &&
    filtros.idsMotivosDesqualificacaoLeadSistemaOrigem.length > 0
  ) {
    filtrosAPI.idsMotivosDesqualificacaoLeadSistemaOrigem =
      filtros.idsMotivosDesqualificacaoLeadSistemaOrigem.map(
        (item) => item.value
      );
  }

  // Lead é cliente
  if (filtros.leadCliente === "sim") {
    filtrosAPI.leadCliente = true;
  } else if (filtros.leadCliente === "nao") {
    filtrosAPI.leadCliente = false;
  }

  // Visitou empreendimento
  if (filtros.leadVisitouEmpreendimento === "sim") {
    filtrosAPI.leadVisitouEmpreendimento = true;
  } else if (filtros.leadVisitouEmpreendimento === "nao") {
    filtrosAPI.leadVisitouEmpreendimento = false;
  }

  // Passou pela oferta ativa
  if (filtros.leadPassouPelaOfertaAtiva === "sim") {
    filtrosAPI.leadPassouPelaOfertaAtiva = true;
  } else if (filtros.leadPassouPelaOfertaAtiva === "nao") {
    filtrosAPI.leadPassouPelaOfertaAtiva = false;
  }

  // Quantidade de vezes na oferta ativa
  if (filtros.quantidadeVezesLeadPassouPelaOfertaAtiva) {
    filtrosAPI.quantidadeVezesLeadPassouPelaOfertaAtiva = parseInt(
      filtros.quantidadeVezesLeadPassouPelaOfertaAtiva.value,
      10
    );
  }

  // Origem
  if (filtros.idsOrigensLeadSistemaOrigem) {
    filtrosAPI.idsOrigensLeadSistemaOrigem = [
      filtros.idsOrigensLeadSistemaOrigem.value,
    ];
  }

  // Canal
  if (filtros.idsCanaisLeadSistemaOrigem) {
    filtrosAPI.idsCanaisLeadSistemaOrigem = [
      filtros.idsCanaisLeadSistemaOrigem.value,
    ];
  }

  // Temperatura
  if (
    filtros.idsTemperaturasLeadSistemaOrigem &&
    filtros.idsTemperaturasLeadSistemaOrigem.length > 0
  ) {
    filtrosAPI.idsTemperaturasLeadSistemaOrigem =
      filtros.idsTemperaturasLeadSistemaOrigem;
  }

  // Renda familiar
  if (filtros.idsRendasFamiliaresLeadSistemaOrigem) {
    filtrosAPI.idsRendasFamiliaresLeadSistemaOrigem = [
      filtros.idsRendasFamiliaresLeadSistemaOrigem.value,
    ];
  }

  // Etapas
  if (filtros.etapas && filtros.etapas.length > 0) {
    filtrosAPI.etapas = filtros.etapas;
  }

  // Subetapas
  if (filtros.idsSubetapasSistemaOrigem) {
    filtrosAPI.idsSubetapasSistemaOrigem = [
      filtros.idsSubetapasSistemaOrigem.value,
    ];
  }

  // Etapas anteriores
  if (filtros.etapasAnterioresLead && filtros.etapasAnterioresLead.length > 0) {
    filtrosAPI.etapasAnterioresLead = filtros.etapasAnterioresLead;
  }

  // Subetapas anteriores
  if (
    filtros.idsSubEtapasAnterioresLeadSistemaOrigem &&
    filtros.idsSubEtapasAnterioresLeadSistemaOrigem.length > 0
  ) {
    filtrosAPI.idsSubEtapasAnterioresLeadSistemaOrigem =
      filtros.idsSubEtapasAnterioresLeadSistemaOrigem.map((item) => item.value);
  }

  // Produto de interesse
  if (
    filtros.idsProdutosInteresseSistemaOrigem &&
    filtros.idsProdutosInteresseSistemaOrigem.length > 0
  ) {
    filtrosAPI.idsProdutosInteresseSistemaOrigem =
      filtros.idsProdutosInteresseSistemaOrigem.map((item) => item.value);
  }

  // Visualizar sem produtos
  if (filtros.apenasLeadsSemProdutos) {
    filtrosAPI.apenasLeadsSemProdutos = filtros.apenasLeadsSemProdutos;
  }

  // Tipo de empreendimento
  if (
    filtros.idsTiposEmpreendimentosSistemaOrigem &&
    filtros.idsTiposEmpreendimentosSistemaOrigem.length > 0
  ) {
    filtrosAPI.idsTiposEmpreendimentosSistemaOrigem =
      filtros.idsTiposEmpreendimentosSistemaOrigem;
  }

  // Dormitórios
  if (
    filtros.quantidadesDormitorios &&
    filtros.quantidadesDormitorios.length > 0
  ) {
    filtrosAPI.quantidadesDormitorios = filtros.quantidadesDormitorios.map(
      (d: string) => parseInt(d, 10)
    );
  }

  // Zona
  if (
    filtros.idsZonasEmpreendimentosSistemaOrigem &&
    filtros.idsZonasEmpreendimentosSistemaOrigem.length > 0
  ) {
    filtrosAPI.idsZonasEmpreendimentosSistemaOrigem =
      filtros.idsZonasEmpreendimentosSistemaOrigem;
  }

  // Bairro
  if (
    filtros.idsBairrosEmpreendimentosSistemaOrigem &&
    filtros.idsBairrosEmpreendimentosSistemaOrigem.length > 0
  ) {
    filtrosAPI.idsBairrosEmpreendimentosSistemaOrigem =
      filtros.idsBairrosEmpreendimentosSistemaOrigem.map((item) => item.value);
  }

  // Valor do imóvel
  if (filtros.inicioIntervaloValorImovel) {
    // Remove formatação da moeda e converte para string
    const valor = filtros.inicioIntervaloValorImovel.replace(/[R$\s.,]/g, "");
    if (valor) {
      filtrosAPI.inicioIntervaloValorImovel = valor;
    }
  }
  if (filtros.fimIntervaloValorImovel) {
    // Remove formatação da moeda e converte para string
    const valor = filtros.fimIntervaloValorImovel.replace(/[R$\s.,]/g, "");
    if (valor) {
      filtrosAPI.fimIntervaloValorImovel = valor;
    }
  }

  // Objetivos da compra
  if (
    filtros.idsObjetivosCompraSistemaOrigem &&
    filtros.idsObjetivosCompraSistemaOrigem.length > 0
  ) {
    filtrosAPI.idsObjetivosCompraSistemaOrigem =
      filtros.idsObjetivosCompraSistemaOrigem;
  }

  // Prazo de entrega
  if (
    filtros.idsPrazosEntregaSistemaOrigem &&
    filtros.idsPrazosEntregaSistemaOrigem.length > 0
  ) {
    filtrosAPI.idsPrazosEntregaSistemaOrigem =
      filtros.idsPrazosEntregaSistemaOrigem;
  }

  return filtrosAPI;
};
